/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React, { PureComponent, Fragment } from 'react';
import {
  Col, Badge,
} from 'reactstrap';
import TableCell from '@material-ui/core/TableCell';
import { connect } from 'react-redux';
import QueryString from 'query-string';
import Skeleton from 'react-loading-skeleton';
import map from 'lodash/map';
import PropTypes from 'prop-types';
import MatTable from '../../../shared/components/MaterialTable';
import { getUsers, deleteUser } from '../../../redux/actions/userActions';
import { changeTitleAction } from '../../../redux/actions/topbarActions';
import Modal from '../../../shared/components/Modal';
import CModal from '../../../shared/components/Modal/Modal';
import { isUserAllowed, setRUTFormat } from '../../../shared/utils';
import { rolesFormatter } from '../../../helper/functions';
import { ROLES } from '../../../helper/constants';
import { some } from 'lodash';

let headUser = [
  {
    id: 'Usuarios', label: 'Usuarios',
  },
  {
    id: 'Correo', label: 'Correo',
  },
  {
    id: 'rut', label: 'RUT',
  },
  {
    id: 'Roles', label: 'Roles',
  },
  {
    id: 'Habilidades', label: 'Habilidades',
  },
  {
    id: 'Anexo', label: 'Anexo',
  },
  {
    id: 'status', label: 'Estado',
  }
];

const NewUser = {
  _id: null,
  modal: false,
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  anexo: '',
  // denwaPassword: '',
  rut: '',
  titleModal: '',
  roles: [],
  avatar: '',
};

class UserList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      order: 'asc',
      orderBy: 'calories',
      selected: [],
      data: [],
      page: 0,
      rowsPerPage: 10,
      isOpenModal: false,
      isOpenCModal: false,
      user: null,
    };
    this.modal = null;
  }

  componentDidMount() {
    if (!isUserAllowed(ROLES.auditor) && !some(headUser, e => e.id === 'Acciones')) {
      headUser.push({ id: 'Acciones', label: 'Acciones' });
    }
    let { page = 0, limit = 10 } = QueryString.parse(this.props.location.location.search);
    const query = {};
    if (page && !Number.isNaN(page)) {
      page = parseInt(page, 10) - 1;
      Object.assign(query, { page: page + 1 });
    }
    if (limit && !Number.isNaN(limit)) {
      limit = parseInt(limit, 10);
      Object.assign(query, { limit });
    }

    this.setState({ page, rowsPerPage: limit });

    this.props.getUsers({ ...query }, (users) => {
      this.setState({ data: users });
    });
    this.props.changeTitleAction('Usuarios');
  }

  componentWillUnmount() {
    this.props.changeTitleAction('');
  }

  getUsers = () => {
    this.props.getUsers({}, (users) => {
      this.setState({ data: users });
    });
  }

  createUser = () => {
    this.setState({
      isOpenModal: true,
      titleModal: 'Nuevo Usuario',
    });
    if (this.modal) {
      this.modal.setData({ ...NewUser });
    }
  }

  onChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
    const query = QueryString.parse(this.props.location.location.search);
    this.props.location.history.push(`/usuarios?${QueryString.stringify({ ...query, limit: rowsPerPage })}`);
    this.props.getUsers({ ...query, limit: rowsPerPage }, (users) => {
      this.setState({ data: users });
    });
  }

  onChangePage = (page) => {
    this.setState({ page });
    const query = QueryString.parse(this.props.location.location.search);
    this.props.location.history.push(`/usuarios?${QueryString.stringify({ ...query, page: page + 1 })}`);
    this.props.getUsers({ ...query, page: page + 1 }, (users) => {
      this.setState({ data: users });
    });
  }

  prepareUserData = (user) => {
    const parsedUser = JSON.parse(JSON.stringify(user));
    if (user.subtype && user.subtype.length > 0) {
      parsedUser.subtype = map(user.subtype, item => ({ value: item._id, label: item.name }));
    }
    return parsedUser;
  }

  onClickAction = (action, item) => () => {
    switch (action) {
      case 'delete':
        this.deleteUser(item);
        break;
      case 'update':
        this.uploadUser(this.prepareUserData(item));
        break;
      default:
        break;
    }
  }

  uploadUser = (item) => {
    this.setState({
      isOpenModal: true,
      titleModal: 'Editar Usuario',
    });
    if (this.modal) {
      this.modal.setData(item);
    }
  }

  deleteUser = (item) => {
    this.setState({ isOpenCModal: true, item });
  }

  setModalRef = (e) => {
    this.modal = e;
  };

  onClose = (isOk) => {
    this.setState({ isOpenModal: false, user: null });
    if (isOk) {
      this.getUsers();
    }
  }

  toggleCModal = isOk => () => {
    if (isOk) {
      this.props.deleteUser(this.state.item._id, () => {
        this.setState({ isOpenCModal: false, item: null });
        this.getUsers();
      });
    } else {
      this.setState({ isOpenCModal: false });
    }
  }

  render() {
    const { selected, rowsPerPage, page } = this.state;
    const { cargando, total, users } = this.props;

    const data = users.map((d) => ({
      id: d._id,
      cells: (
        <Fragment key={`${d._id}`}>
          <TableCell
            className="material-table__cell"
            scope="row"
            padding="none"
          >
            {`${d.firstName} ${d.lastName}`}
          </TableCell>
          <TableCell className="material-table__cell" align="left">{d.email}</TableCell>
          <TableCell
            className="material-table__cell"
            scope="row"
            padding="none"
          >{setRUTFormat(d.rut)}
          </TableCell>
          <TableCell className="material-table__cell" align="left">{d.roles.map((role) => (
            <span key={`${d._id}-${role}`}><Badge color="secondary">{rolesFormatter(role)}</Badge> </span>
          ))}
          </TableCell>
          <TableCell className="material-table__cell" align="left">
            {d.subtype ? d.subtype.length : 0}
          </TableCell>
          <TableCell className="material-table__cell" align="left">{d.anexo}</TableCell>
          <TableCell className="material-table__cell" align="left">{d.status ? 'Activo' : 'Inactivo'}</TableCell>
          {!isUserAllowed(ROLES.auditor) && <TableCell className="material-table__cell" align="left"          >
            <a href="javascript:void(0);" onClick={this.onClickAction('update', d)}>
              <span
                className="lnr lnr-lnr lnr-pencil"
                style={{
                  fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', color: '#000',
                }}
              />
            </a>
            <a href="javascript:void(0);" onClick={this.onClickAction('delete', d)} style={{ marginLeft: '15%' }}>
              <span
                className="lnr lnr-lnr lnr-trash"
                style={{
                  fontSize: '20px', fontWeight: 'bold', cursor: 'pointer', color: '#000',
                }}
              />
            </a>
          </TableCell>}
        </Fragment>
      ),
    }));

    return (
      <Col md={12} lg={12}>
        <Modal
          isOpen={this.state.isOpenModal}
          onClose={this.onClose}
          ref={this.setModalRef}
          user={this.state.user}
          title={this.state.titleModal}
        />
        <CModal
          color="warning"
          title="¡Atención!"
          message="¿Está seguro que desea eliminar el usuario?"
          toggle={this.toggleCModal}
          isOpen={this.state.isOpenCModal}
        />
        {cargando && (<Skeleton count={rowsPerPage + 1} height={40} />)}
        {!cargando && (
          <MatTable
            onSelectAllClick={this.onSelectAllClick}
            onChangePage={this.onChangePage}
            cargando={cargando}
            onChangeRowsPerPage={this.onChangeRowsPerPage}
            selected={selected}
            headers={headUser}
            data={data}
            page={page}
            rowsPerPage={rowsPerPage}
            total={total}
          />
        )}
      </Col>
    );
  }
}

UserList.propTypes = {
  getUsers: PropTypes.func,
  changeTitleAction: PropTypes.func,
  deleteUser: PropTypes.func,
  cargando: PropTypes.bool,
  total: PropTypes.string,
  users: PropTypes.array,
  location: PropTypes.shape({
    location: PropTypes.shape({ search: PropTypes.string }),
    history: PropTypes.shape({ push: PropTypes.func }),
  }),
};

const mapStateToProps = ({ users }) => ({
  users: users.collection,
  cargando: users.cargando,
  total: users.total,
  limit: users.limit,
});


const mapDispatchToProps = {
  getUsers,
  deleteUser,
  changeTitleAction,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(UserList);
